(function () {
  const MODAL_ID = 'QuoteCartModal';
  const STORAGE_KEY = 'spengman_quote_cart_v1';
  const CONTACT_STORAGE_KEY = 'spengman_quote_contact_v1';
  const CONTACT_STORAGE_TTL_MS = 30 * 60 * 1000;
  const SUBMIT_PENDING_KEY = 'spengman_quote_submit_pending_v1';
  const SUCCESS_FLASH_KEY = 'spengman_quote_submit_success_v1';
  const THANK_YOU_MESSAGE = 'Tack! Vi återkommer så fort vi kan.';
  const SCROLL_COMPENSATE_CLASS = 'quote-cart-scroll-compensate';

  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  const dialog = modal.querySelector('.quote-cart-modal__dialog');
  const panels = {
    1: modal.querySelector('[data-quote-step-panel="1"]'),
    2: modal.querySelector('[data-quote-step-panel="2"]'),
  };
  const indicators = Array.from(modal.querySelectorAll('[data-quote-step-indicator]'));
  const stepOneItems = modal.querySelector('[data-quote-items-step-one]');
  const stepTwoItems = modal.querySelector('[data-quote-items-step-two]');
  const emptyMessage = modal.querySelector('[data-quote-empty-message]');
  const errorMessage = modal.querySelector('[data-quote-error-message]');
  const successMessage = modal.querySelector('[data-quote-success-message]');
  const submitButton = modal.querySelector('[data-quote-submit-button]');
  const nextButton = modal.querySelector('[data-quote-action="next"]');
  const backButton = modal.querySelector('[data-quote-action="back"]');
  const contactFields = Array.from(modal.querySelectorAll('[data-quote-contact-field]'));
  const submitForm = modal.querySelector('#QuoteCartContactForm');
  const submitBodyField = modal.querySelector('[data-quote-submit-body]');
  const emailInput = modal.querySelector('#QuoteCartEmail');
  const postalCodeInput = modal.querySelector('#QuoteCartPostalCode');
  const nameInput = modal.querySelector('#QuoteCartName');
  const phoneInput = modal.querySelector('#QuoteCartPhone');
  const companyInput = modal.querySelector('#QuoteCartCompany');
  const orgNumberInput = modal.querySelector('#QuoteCartOrgNumber');
  const deliveryAddressInput = modal.querySelector('#QuoteCartDeliveryAddress');
  const deliveryZipInput = modal.querySelector('#QuoteCartDeliveryZip');
  const deliveryCityInput = modal.querySelector('#QuoteCartDeliveryCity');
  const billingAddressInput = modal.querySelector('#QuoteCartBillingAddress');
  const billingZipInput = modal.querySelector('#QuoteCartBillingZip');
  const billingCityInput = modal.querySelector('#QuoteCartBillingCity');
  const messageInput = modal.querySelector('#QuoteCartMessage');

  if (
    !dialog ||
    !panels[1] ||
    !panels[2] ||
    !stepOneItems ||
    !stepTwoItems ||
    !emptyMessage ||
    !errorMessage ||
    !submitButton ||
    !nextButton ||
    !backButton ||
    !submitForm ||
    !submitBodyField
  ) {
    return;
  }

  let step = 1;
  let state = loadState();
  const shouldShowSuccess = consumeSubmitSuccess();
  if (shouldShowSuccess) {
    clearQuoteCart();
    clearSensitiveContactState();
  }
  hydrateContactForm();
  render();

  if (shouldShowSuccess) {
    openModal();
    showSuccess(THANK_YOU_MESSAGE);
  }

  const openStateObserver = new MutationObserver(() => {
    if (!modal.hasAttribute('open')) {
      clearBodyScrollCompensation();
    }
  });
  openStateObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-quote-add]');
    if (!addButton) return;
    event.preventDefault();
    addProduct(addButton);
    openModal(addButton);
  });

  modal.addEventListener('click', (event) => {
    const actionButton = event.target.closest('[data-quote-action]');
    const removeButton = event.target.closest('[data-quote-remove-item]');

    if (removeButton) {
      removeItem(removeButton.dataset.quoteRemoveItem);
      return;
    }

    if (!actionButton) return;
    const action = actionButton.dataset.quoteAction;

    if (action === 'continue') {
      if (typeof modal.hide === 'function') {
        modal.hide();
      } else {
        modal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
      return;
    }

    if (action === 'next') {
      if (state.items.length === 0) {
        showError('Lägg till minst en produkt i offert-kundvagnen.');
        return;
      }
      clearError();
      clearSuccess();
      setStep(2);
      return;
    }

    if (action === 'back') {
      clearError();
      clearSuccess();
      setStep(1);
      return;
    }

  });

  modal.addEventListener('input', (event) => {
    const qtyInput = event.target.closest('[data-quote-qty-input]');
    if (qtyInput) {
      updateQuantity(qtyInput.dataset.quoteQtyInput, qtyInput.value, { rerender: false });
      return;
    }

    const noteInput = event.target.closest('[data-quote-note-input]');
    if (noteInput) {
      updateNote(noteInput.dataset.quoteNoteInput, noteInput.value);
      return;
    }
  });

  modal.addEventListener('change', (event) => {
    const qtyInput = event.target.closest('[data-quote-qty-input]');
    if (!qtyInput) return;

    updateQuantity(qtyInput.dataset.quoteQtyInput, qtyInput.value, {
      rerender: true,
      inputElement: qtyInput,
    });
  });

  contactFields.forEach((field) => {
    field.addEventListener('input', () => {
      state.contact[field.dataset.quoteContactField] = field.value;
      saveState();
    });
  });

  submitForm.addEventListener('submit', onQuoteFormSubmit);

  function defaultState() {
    return {
      items: [],
      contact: {
        email: '',
        postal_code: '',
        name: '',
        phone: '',
        company: '',
        org_number: '',
        message: '',
        delivery_address: '',
        delivery_zip: '',
        delivery_city: '',
        billing_address: '',
        billing_zip: '',
        billing_city: '',
      },
    };
  }

  function loadState() {
    const initial = defaultState();

    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (parsed && typeof parsed === 'object') {
        initial.items = Array.isArray(parsed.items) ? parsed.items.filter(Boolean) : [];

        // Legacy cleanup: older versions stored contact data in localStorage.
        if (parsed.contact && typeof parsed.contact === 'object') {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({ items: initial.items }));
        }
      }
    } catch (error) {
      // Ignore local storage read errors and keep defaults.
    }

    try {
      const parsedContact = JSON.parse(sessionStorage.getItem(CONTACT_STORAGE_KEY));
      if (
        parsedContact &&
        typeof parsedContact === 'object' &&
        parsedContact.contact &&
        typeof parsedContact.contact === 'object'
      ) {
        const updatedAt = Number(parsedContact.updated_at) || 0;
        if (updatedAt > 0 && Date.now() - updatedAt <= CONTACT_STORAGE_TTL_MS) {
          initial.contact = Object.assign(initial.contact, parsedContact.contact);
        } else {
          sessionStorage.removeItem(CONTACT_STORAGE_KEY);
        }
      }
    } catch (error) {
      // Ignore session storage read errors and keep defaults.
    }

    return initial;
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ items: state.items }));
    } catch (error) {
      // Ignore storage errors (private mode / quota) and keep runtime state.
    }

    persistContactState();
  }

  function persistContactState() {
    try {
      if (isContactEmpty(state.contact)) {
        sessionStorage.removeItem(CONTACT_STORAGE_KEY);
        return;
      }

      sessionStorage.setItem(
        CONTACT_STORAGE_KEY,
        JSON.stringify({
          contact: state.contact,
          updated_at: Date.now(),
        })
      );
    } catch (error) {
      // Ignore session storage write errors.
    }
  }

  function openModal(opener) {
    applyBodyScrollCompensation();
    if (typeof modal.show === 'function') {
      modal.show(opener);
    } else {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }
    clearError();
    clearSuccess();
    setStep(1);
    render();
  }

  function setStep(nextStep) {
    step = nextStep;
    indicators.forEach((indicator) => {
      indicator.classList.toggle('is-active', parseInt(indicator.dataset.quoteStepIndicator, 10) === step);
    });
    Object.keys(panels).forEach((panelStep) => {
      panels[panelStep].classList.toggle('is-active', parseInt(panelStep, 10) === step);
    });

    const onStepTwo = step === 2;
    submitButton.classList.toggle('hidden', !onStepTwo);
    backButton.classList.toggle('hidden', !onStepTwo);
    nextButton.classList.toggle('hidden', onStepTwo);
  }

  function normalizeProductData(button) {
    const liveVariantData = resolveCurrentVariantData(button);
    const variantId = liveVariantData.variantId || button.dataset.quoteVariantId;
    if (!variantId) return null;

    const hasLiveVariant = Boolean(liveVariantData.variantId);
    const variantTitle = hasLiveVariant
      ? liveVariantData.variantTitle || ''
      : button.dataset.quoteVariantTitle || '';
    const sku = hasLiveVariant ? liveVariantData.sku || '' : button.dataset.quoteSku || '';
    const imageUrl = hasLiveVariant ? liveVariantData.imageUrl || '' : button.dataset.quoteImage || '';

    // Keep button dataset in sync so repeated clicks stay on latest variant data.
    button.dataset.quoteVariantId = String(variantId);
    button.dataset.quoteVariantTitle = variantTitle;
    button.dataset.quoteSku = sku;
    button.dataset.quoteImage = imageUrl;

    return {
      key: String(variantId),
      productId: button.dataset.quoteProductId || '',
      variantId: String(variantId),
      productTitle: button.dataset.quoteProductTitle || 'Produkt',
      productUrl: button.dataset.quoteProductUrl || '',
      variantTitle: variantTitle === 'Default Title' ? '' : variantTitle,
      sku,
      imageUrl,
      quantity: 1,
      note: '',
    };
  }

  function resolveCurrentVariantData(button) {
    const productInfo = findRelatedProductInfo(button);
    if (!productInfo) return {};

    const selectedVariant = getSelectedVariant(productInfo);
    if (selectedVariant && selectedVariant.id) {
      return {
        variantId: String(selectedVariant.id),
        variantTitle: selectedVariant.title || '',
        sku: selectedVariant.sku || '',
        imageUrl: normalizeAssetUrl(
          selectedVariant?.featured_image?.src
            || selectedVariant?.featured_media?.preview_image?.src
            || selectedVariant?.image?.src
            || selectedVariant?.image?.url
            || ''
        ),
      };
    }

    const fallbackVariantInput = productInfo.querySelector(
      '.product-form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"], input.product-variant-id'
    );

    if (fallbackVariantInput && fallbackVariantInput.value) {
      return { variantId: String(fallbackVariantInput.value) };
    }

    try {
      const url = new URL(window.location.href);
      const variantIdFromUrl = url.searchParams.get('variant');
      if (variantIdFromUrl) {
        return { variantId: variantIdFromUrl };
      }
    } catch (error) {
      // Ignore URL parsing errors and fallback to button dataset.
    }

    return {};
  }

  function findRelatedProductInfo(button) {
    const closestProductInfo = button.closest('product-info');
    if (closestProductInfo) {
      return closestProductInfo;
    }

    const productId = button.dataset.quoteProductId;
    if (productId) {
      const matchingProductInfo = document.querySelector(`product-info[data-product-id="${productId}"]`);
      if (matchingProductInfo) {
        return matchingProductInfo;
      }
    }

    return document.querySelector('product-info');
  }

  function getSelectedVariant(productInfo) {
    const selectedVariantScript = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantScript) return null;

    try {
      return JSON.parse(selectedVariantScript.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  function normalizeAssetUrl(url) {
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    if (url.startsWith('/')) return `${window.location.origin}${url}`;
    return url;
  }

  function addProduct(button) {
    const item = normalizeProductData(button);
    if (!item) return;

    const existing = state.items.find((storedItem) => storedItem.key === item.key);
    if (existing) {
      existing.quantity += 1;
    } else {
      state.items.push(item);
    }

    saveState();
    render();
  }

  function removeItem(itemKey) {
    state.items = state.items.filter((item) => item.key !== itemKey);
    saveState();
    render();
  }

  function updateQuantity(itemKey, value, options) {
    const settings = Object.assign(
      {
        rerender: true,
        inputElement: null,
      },
      options || {}
    );
    const item = state.items.find((storedItem) => storedItem.key === itemKey);
    if (!item) return;

    const normalizedValue = Math.max(1, parseInt(value, 10) || 1);
    item.quantity = normalizedValue;
    saveState();

    if (settings.inputElement) {
      settings.inputElement.value = String(normalizedValue);
    }

    if (settings.rerender) {
      render();
    }
  }

  function updateNote(itemKey, value) {
    const item = state.items.find((storedItem) => storedItem.key === itemKey);
    if (!item) return;
    item.note = value;
    saveState();
  }

  function hydrateContactForm() {
    contactFields.forEach((field) => {
      const key = field.dataset.quoteContactField;
      field.value = state.contact[key] || '';
    });
  }

  function render() {
    renderStepOne();
    renderStepTwo();
    const hasItems = state.items.length > 0;
    nextButton.disabled = !hasItems;
    submitButton.disabled = !hasItems;
  }

  function renderStepOne() {
    if (state.items.length === 0) {
      stepOneItems.innerHTML = '';
      emptyMessage.classList.remove('hidden');
      return;
    }

    emptyMessage.classList.add('hidden');
    stepOneItems.innerHTML = state.items.map((item) => stepOneItemTemplate(item)).join('');
  }

  function renderStepTwo() {
    if (state.items.length === 0) {
      stepTwoItems.innerHTML = '<p>Inga produkter valda.</p>';
      return;
    }
    stepTwoItems.innerHTML = state.items.map((item) => stepTwoItemTemplate(item)).join('');
  }

  function stepOneItemTemplate(item) {
    const image = item.imageUrl
      ? `<img class="quote-cart-item__image" src="${escapeHtml(item.imageUrl)}" alt="${escapeHtml(item.productTitle)}" loading="lazy" width="72" height="72">`
      : '';

    const variantLine = item.variantTitle ? `<div class="quote-cart-item__meta">${escapeHtml(item.variantTitle)}</div>` : '';
    const skuLine = item.sku ? `<div class="quote-cart-item__meta">#: ${escapeHtml(item.sku)}</div>` : '';
    const itemTitle = item.productUrl
      ? `<a href="${escapeHtml(item.productUrl)}" class="full-unstyled-link quote-cart-item__title">${escapeHtml(item.productTitle)}</a>`
      : `<p class="quote-cart-item__title">${escapeHtml(item.productTitle)}</p>`;

    return `
      <article class="quote-cart-item">
        <div class="quote-cart-item__meta-wrap">
          <div class="quote-cart-item__product">
            ${image}
            <div>
              ${itemTitle}
              ${variantLine}
              ${skuLine}
            </div>
          </div>
        </div>
        <div class="quote-cart-item__qty-wrap">
          <label class="quote-cart-item__label" for="quote-cart-qty-${escapeHtml(item.key)}">Antal</label>
          <input
            id="quote-cart-qty-${escapeHtml(item.key)}"
            class="quote-cart-input"
            type="number"
            min="1"
            step="1"
            value="${escapeHtml(item.quantity)}"
            data-quote-qty-input="${escapeHtml(item.key)}"
          >
        </div>
        <button type="button" class="button button--tertiary color-scheme-cb56c251-1432-4b5b-b8ae-1660a0ce1f88 quote-cart-item__remove" data-quote-remove-item="${escapeHtml(item.key)}">
          Ta bort
        </button>
        <div class="quote-cart-item__note-wrap">
          <label class="quote-cart-item__label" for="quote-cart-note-${escapeHtml(item.key)}">Frågor om produkten</label>
          <textarea
            id="quote-cart-note-${escapeHtml(item.key)}"
            class="quote-cart-input quote-cart-input--textarea"
            rows="2"
            placeholder="Fyll i dina frågor kring produkten"
            data-quote-note-input="${escapeHtml(item.key)}"
          >${escapeHtml(item.note || '')}</textarea>
        </div>
      </article>
    `;
  }

  function stepTwoItemTemplate(item) {
    const image = item.imageUrl
      ? `<img class="quote-cart-item__image" src="${escapeHtml(item.imageUrl)}" alt="${escapeHtml(item.productTitle)}" loading="lazy" width="60" height="60">`
      : '';

    const variantLine = item.variantTitle ? `<div class="quote-cart-item__meta">${escapeHtml(item.variantTitle)}</div>` : '';
    const skuLine = item.sku ? `<div class="quote-cart-item__meta">#: ${escapeHtml(item.sku)}</div>` : '';
    const noteLine = item.note ? `<p class="quote-cart-summary__note">- Frågor om produkten: ${escapeHtml(item.note)}</p>` : '';

    return `
      <article class="quote-cart-summary__item">
        ${image}
        <div>
          <strong>${escapeHtml(item.productTitle)}</strong>
          ${variantLine}
          ${skuLine}
          ${noteLine}
        </div>
        <div class="quote-cart-summary__qty">${escapeHtml(item.quantity)} st</div>
      </article>
    `;
  }

  function onQuoteFormSubmit(event) {
    const email = ((emailInput && emailInput.value) || state.contact.email || '').trim();
    if (!email) {
      event.preventDefault();
      showError('Fyll i e-postadress innan du skickar förfrågan.');
      if (emailInput) emailInput.focus();
      submitButton.disabled = false;
      return;
    }

    // Basic email format validation to complement HTML5 validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      event.preventDefault();
      showError('Ogiltig e-postadress. Kontrollera att den är korrekt angiven.');
      if (emailInput) emailInput.focus();
      submitButton.disabled = false;
      return;
    }
    const postalCode = ((postalCodeInput && postalCodeInput.value) || state.contact.postal_code || '').trim();
    if (!postalCode) {
      event.preventDefault();
      showError('Fyll i postnummer innan du skickar förfrågan.');
      if (postalCodeInput) postalCodeInput.focus();
      submitButton.disabled = false;
      return;
    }

    if (state.items.length === 0) {
      event.preventDefault();
      showError('Lägg till minst en produkt i offert-kundvagnen.');
      setStep(1);
      submitButton.disabled = false;
      return;
    }

    if (!submitBodyField) {
      event.preventDefault();
      showError('Kunde inte skicka offertförfrågan just nu. Försök igen.');
      submitButton.disabled = false;
      return;
    }

    const name = ((nameInput && nameInput.value) || state.contact.name || '').trim();
    const phone = ((phoneInput && phoneInput.value) || state.contact.phone || '').trim();
    const company = ((companyInput && companyInput.value) || state.contact.company || '').trim();
    const orgNumber = ((orgNumberInput && orgNumberInput.value) || state.contact.org_number || '').trim();
    const deliveryAddress = ((deliveryAddressInput && deliveryAddressInput.value) || state.contact.delivery_address || '').trim();
    const deliveryZip = ((deliveryZipInput && deliveryZipInput.value) || state.contact.delivery_zip || '').trim();
    const deliveryCity = ((deliveryCityInput && deliveryCityInput.value) || state.contact.delivery_city || '').trim();
    const billingAddress = ((billingAddressInput && billingAddressInput.value) || state.contact.billing_address || '').trim();
    const billingZip = ((billingZipInput && billingZipInput.value) || state.contact.billing_zip || '').trim();
    const billingCity = ((billingCityInput && billingCityInput.value) || state.contact.billing_city || '').trim();
    const message = ((messageInput && messageInput.value) || state.contact.message || '').trim();

    state.contact.email = email;
    state.contact.postal_code = postalCode;
    state.contact.name = name;
    state.contact.phone = phone;
    state.contact.company = company;
    state.contact.org_number = orgNumber;
    state.contact.delivery_address = deliveryAddress;
    state.contact.delivery_zip = deliveryZip;
    state.contact.delivery_city = deliveryCity;
    state.contact.billing_address = billingAddress;
    state.contact.billing_zip = billingZip;
    state.contact.billing_city = billingCity;
    state.contact.message = message;
    saveState();

    clearError();
    clearSuccess();
    submitBodyField.value = buildContactBody();

    markSubmitPending();
    submitButton.disabled = true;
    window.setTimeout(() => {
      submitButton.disabled = false;
    }, 6000);
  }

  function buildContactBody() {
    const lines = [];
    let renderedSections = 0;
    lines.push('OFFERTFÖRFRÅGAN');
    lines.push('');

    addSection('OFFERTINFORMATION', [
      `Butik: ${dialog.dataset.shopName || ''}`,
      'Källa: Offert-kundvagn',
    ]);

    const productLines = [];
    state.items.forEach((item, index) => {
      productLines.push(`${index + 1}. ${item.productTitle}`);
      if (item.variantTitle) productLines.push(`   Variant: ${item.variantTitle}`);
      if (item.sku) productLines.push(`   SKU: ${item.sku}`);
      productLines.push(`   Antal: ${item.quantity}`);
      if (item.note) productLines.push(`   Fråga: ${item.note}`);
      productLines.push('');
    });
    addSection('PRODUKTER', productLines);

    addSection('KONTAKTINFORMATION', [
      `E-post: ${state.contact.email || ''}`,
      `Postnummer: ${state.contact.postal_code || ''}`,
      `Namn: ${state.contact.name || ''}`,
      `Telefon: ${state.contact.phone || ''}`,
      `Företag: ${state.contact.company || ''}`,
      `Org.nr: ${state.contact.org_number || ''}`,
    ]);

    const deliveryLines = [];
    if (state.contact.delivery_address) deliveryLines.push(`Adress: ${state.contact.delivery_address}`);
    if (state.contact.delivery_zip) deliveryLines.push(`Postnummer: ${state.contact.delivery_zip}`);
    if (state.contact.delivery_city) deliveryLines.push(`Ort: ${state.contact.delivery_city}`);
    addSection('LEVERANSADRESS', deliveryLines);

    const billingLines = [];
    if (state.contact.billing_address) billingLines.push(`Adress: ${state.contact.billing_address}`);
    if (state.contact.billing_zip) billingLines.push(`Postnummer: ${state.contact.billing_zip}`);
    if (state.contact.billing_city) billingLines.push(`Ort: ${state.contact.billing_city}`);
    addSection('FAKTURERINGSADRESS', billingLines);

    if (state.contact.message) {
      const messageLines = String(state.contact.message).split('\n').map((row) => row.trimEnd());
      addSection('MEDDELANDE', messageLines);
    }

    return lines.join('\n');

    function addSection(title, sectionLines) {
      const normalizedLines = Array.isArray(sectionLines) ? sectionLines.filter(Boolean) : [];
      if (normalizedLines.length === 0) return;

      if (renderedSections > 0) {
        lines.push('----------------------------------------');
        lines.push('');
      }

      lines.push(`${title}:`);
      normalizedLines.forEach((line) => {
        lines.push(line);
      });
      lines.push('');
      renderedSections += 1;
    }
  }

  function clearQuoteCart() {
    state = defaultState();
    saveState();
  }

  function clearSensitiveContactState() {
    if (isContactEmpty(state.contact)) return;

    state.contact = defaultState().contact;
    saveState();
    hydrateContactForm();
  }

  function isContactEmpty(contact) {
    if (!contact || typeof contact !== 'object') return true;

    return Object.keys(contact).every((key) => {
      const value = contact[key];
      if (value == null) return true;
      return String(value).trim() === '';
    });
  }

  function markSubmitPending() {
    try {
      sessionStorage.setItem(SUBMIT_PENDING_KEY, '1');
    } catch (error) {
      // Ignore session storage errors.
    }
  }

  function applyBodyScrollCompensation() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth <= 0) {
      clearBodyScrollCompensation();
      return;
    }

    document.body.style.setProperty('--quote-cart-scrollbar-width', `${scrollbarWidth}px`);
    document.body.classList.add(SCROLL_COMPENSATE_CLASS);
  }

  function clearBodyScrollCompensation() {
    document.body.classList.remove(SCROLL_COMPENSATE_CLASS);
    document.body.style.removeProperty('--quote-cart-scrollbar-width');
  }

  function consumeSubmitSuccess() {
    try {
      const pendingSubmit = sessionStorage.getItem(SUBMIT_PENDING_KEY) === '1';
      if (pendingSubmit && isContactPostedSuccess()) {
        sessionStorage.removeItem(SUBMIT_PENDING_KEY);
        sessionStorage.setItem(SUCCESS_FLASH_KEY, '1');
      }

      const shouldShowSuccess = sessionStorage.getItem(SUCCESS_FLASH_KEY) === '1';
      if (!shouldShowSuccess) {
        return false;
      }

      sessionStorage.removeItem(SUCCESS_FLASH_KEY);
      cleanupSuccessQueryParam();
      return true;
    } catch (error) {
      return false;
    }
  }

  function isContactPostedSuccess() {
    try {
      const url = new URL(window.location.href);
      const contactPosted = url.searchParams.get('contact_posted');
      return contactPosted === 'true' || contactPosted === '1';
    } catch (error) {
      return false;
    }
  }

  function cleanupSuccessQueryParam() {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('contact_posted')) return;
      url.searchParams.delete('contact_posted');
      const nextSearch = url.searchParams.toString();
      const nextUrl = `${url.pathname}${nextSearch ? `?${nextSearch}` : ''}${url.hash}`;
      window.history.replaceState({}, '', nextUrl);
    } catch (error) {
      // Ignore history API failures.
    }
  }

  function showError(message) {
    errorMessage.textContent = message;
    errorMessage.classList.remove('hidden');
  }

  function clearError() {
    errorMessage.textContent = '';
    errorMessage.classList.add('hidden');
  }

  function showSuccess(message) {
    if (!successMessage) return;
    successMessage.textContent = message;
    successMessage.classList.remove('hidden');
  }

  function clearSuccess() {
    if (!successMessage) return;
    successMessage.textContent = THANK_YOU_MESSAGE;
    successMessage.classList.add('hidden');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
